export const COMPLETION_STATUSES = new Set([
  'strategy_generated',
  'arts_generated',
  'scheduled',
  'completed',
  'error',
]);

export const buildInitialQueueSteps = (tc) => [
  {text: tc('campaignChat.queue_steps.briefing', {defaultValue: tc('chatsocket.queue_steps.briefing')}), status: 'pending'},
  {text: tc('campaignChat.queue_steps.concept', {defaultValue: tc('chatsocket.queue_steps.concept')}), status: 'idle'},
  {text: tc('campaignChat.queue_steps.writing', {defaultValue: tc('chatsocket.queue_steps.writing')}), status: 'idle'},
  {text: tc('campaignChat.queue_steps.visual_identity', {defaultValue: tc('chatsocket.queue_steps.visual_identity')}), status: 'idle'},
  {text: tc('campaignChat.queue_steps.final_strategy', {defaultValue: tc('chatsocket.queue_steps.final_strategy')}), status: 'idle'},
];

export const buildQueueStepsFromProgress = (progressIndex, initialSteps) => {
  const parsedProgress = Number(progressIndex);
  const completedCount = Number.isFinite(parsedProgress)
    ? Math.max(0, Math.floor(parsedProgress))
    : 0;

  return initialSteps.map((step, index) => {
    if (index < completedCount) {
      return {...step, status: 'complete'};
    }
    if (index === completedCount) {
      return {...step, status: 'pending'};
    }
    return {...step, status: 'idle'};
  });
};

/** Single-step progress for edit/regen of strategy document (legacy parity). */
export const buildDocumentOnlyStrategySteps = (title, status = 'pending') => [
  {text: title, status},
];

const REGEN_STRATEGY_STEP_I18N_KEYS = [
  'campaignChat.strategyProgress.regen.loadingContext',
  'campaignChat.strategyProgress.regen.processingDocument',
  'campaignChat.strategyProgress.regen.persisting',
];

const REGEN_STRATEGY_STEP_DEFAULTS = [
  'Carregando contexto',
  'Processando documento',
  'Persistindo alterações',
];

/** Fixed 3-step template for regerar_documento_estrategia progress. */
export const buildRegenStrategyQueueSteps = (t) =>
  REGEN_STRATEGY_STEP_I18N_KEYS.map((key, index) => ({
    text: t(key, REGEN_STRATEGY_STEP_DEFAULTS[index]),
    status: 'idle',
  }));

export const buildRegenStrategyQueueStepsFromDefaults = () =>
  REGEN_STRATEGY_STEP_DEFAULTS.map((text) => ({text, status: 'idle'}));
